// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"183c8ff4","377":"396e9652","417":"43d592c2","467":"61728a04","626":"e5e40771","870":"62a370d3"}[chunkId] + ".js";
};